<template>
  <div class="page">
    <list
      title="Imóveis"
      tag="properties"
      subtitle="Nesta tela você cria e verifica os templates de consultas de veículos."
      :create-route="{ name: 'Template-Property-Create' }"
    />
  </div>
</template>

<script>
import List from '@/template/components/List.vue';

export default {
  name: 'Index',

  components: {
    List,
  },
};
</script>

<style scoped>

</style>
